import { render, staticRenderFns } from "./FeatureGate.vue?vue&type=template&id=212e7a04&scoped=true"
import script from "./FeatureGate.vue?vue&type=script&lang=js"
export * from "./FeatureGate.vue?vue&type=script&lang=js"
import style0 from "./FeatureGate.vue?vue&type=style&index=0&id=212e7a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e7a04",
  null
  
)

export default component.exports